import { AxiosResponse } from 'axios';
import BaseApi from './BaseApi';
import {
  BackendTokenRedemptionType,
  SignRedeemNotificationPayload, TokenRedemptionDocumentType,
} from 'constants/redemption';
// import { addHours } from "date-fns";

const RedemptionApi = {
  initRedeem(
    token: string,
    payload: {
      tokenId: string;
      privateKey: string;
      type: BackendTokenRedemptionType;
    }
  ): Promise<AxiosResponse> {
    return BaseApi.post('/api/v1/assets/redeem/init', payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  uploadPaymentDocument(
    token: string,
    tokenId: string,
    date: Date,
    document: File
  ): Promise<AxiosResponse> {
    const formData = new FormData();
    formData.append('document', document);
    return BaseApi.post('/api/v1/assets/redeem/payment/upload', formData, {
      params: {
        tokenId,
        // date: addHours(date, 3).toISOString(),
        type: 'PAYMENT_DOC',
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getRedeemPaymentDocument(
    token: string,
    tokenId: string
  ): Promise<AxiosResponse> {
    return BaseApi.get('/api/v1/assets/redeem/payment/document', {
      params: {
        operationId: tokenId,
        type: 'PAYMENT_DOC',
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: 'arraybuffer',
    });
  },
  getRedeemDocument(
    token: string,
    tokenId: string,
    docType: TokenRedemptionDocumentType
  ): Promise<AxiosResponse> {
    return BaseApi.get('/api/v1/assets/redeem/payment/document', {
      params: {
        operationId: tokenId,
        type: docType,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: 'arraybuffer',
    });
  },
  signRedeemPaymentNotification(
    token: string,
    payload: SignRedeemNotificationPayload
  ): Promise<AxiosResponse> {
    return BaseApi.post(
      '/api/v1/assets/redeem/payment/document/sign',
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },
  approveRedeem(
    token: string,
    payload: {
      tokenId: string;
      privateKey: string;
    }
  ): Promise<AxiosResponse> {
    return BaseApi.post('/api/v1/assets/redeem/approve', payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
};

export default RedemptionApi;
